import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21e33501"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "mydiv",
  class: "w-100 h-100"
}
const _hoisted_2 = { style: {"margin-left":"1%"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_4 = { class: "main-div-group-admin" }
const _hoisted_5 = { class: "group-left-div margin-top-bottom-20" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "group-left-div" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "adjusting-position fs-5" }, "Group：")
], -1 /* HOISTED */))
const _hoisted_7 = { class: "display-left-div" }
const _hoisted_8 = ["value"]
const _hoisted_9 = {
  class: "admingrouplist",
  style: {"text-align":"left"}
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div style=\"width:calc(100% - 16px);\" data-v-21e33501><table id=\"tblAdminListInfo\" data-v-21e33501><thead data-v-21e33501><tr data-v-21e33501><th style=\"width:7.5%;\" data-v-21e33501>User ID</th><th style=\"width:8.6%;\" data-v-21e33501>Given Name</th><th style=\"width:8.7%;\" data-v-21e33501>Family Name</th><th style=\"width:11%;\" data-v-21e33501>Group</th><th style=\"width:16%;\" data-v-21e33501>E-mail</th><th style=\"width:22%;\" data-v-21e33501></th></tr></thead></table></div>", 1)
const _hoisted_12 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_13 = {
  key: 1,
  id: "tblbodydiv",
  style: {"width":"calc(100% - 16px)","overflow":"auto"}
}
const _hoisted_14 = { id: "tblAdminListInfo" }
const _hoisted_15 = { id: "tbltbody" }
const _hoisted_16 = { style: {"width":"7.5%"} }
const _hoisted_17 = { style: {"width":"8.6%"} }
const _hoisted_18 = { style: {"width":"8.7%"} }
const _hoisted_19 = { style: {"width":"11%"} }
const _hoisted_20 = { style: {"width":"16%"} }
const _hoisted_21 = { style: {"width":"22%"} }
const _hoisted_22 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Loading"], { isLoading: $setup.isLoading }, null, 8 /* PROPS */, ["isLoading"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["Alert"], {
        alertMessage: $setup.alertMessage,
        alertState: $setup.alertState
      }, null, 8 /* PROPS */, ["alertMessage", "alertState"])
    ]),
    _createVNode($setup["AdminNavigation"], { menuTile: $setup.title }, null, 8 /* PROPS */, ["menuTile"]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            ($setup.store.getters.stationCode == '1000')
              ? _withDirectives((_openBlock(), _createElementBlock("select", {
                  key: 0,
                  class: "adjusting-position form-select group-select",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedGroup) = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.groupList, (group, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      class: "adjusting-option",
                      key: index,
                      value: group['group']
                    }, _toDisplayString(group["group"]), 9 /* TEXT, PROPS */, _hoisted_8))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 512 /* NEED_PATCH */)), [
                  [_vModelSelect, $setup.selectedGroup]
                ])
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", null, [
            ($setup.store.getters.stationCode == '1000')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-primary btnGo",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.goSearch()))
                }, " Go "))
              : _createCommentVNode("v-if", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          ($setup.store.getters.stationCode != '1000')
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, " Add new group admin "))
            : (_openBlock(), _createElementBlock("a", {
                key: 1,
                style: {"cursor":"pointer","color":"blue","text-decoration":"underline"},
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.addGroupAdmin()))
              }, "Add new group admin"))
        ])
      ]),
      _hoisted_11,
      ($setup.groupAdminListInfo.length == 0 && $setup.isNoData)
        ? (_openBlock(), _createElementBlock("h4", _hoisted_12, " No data "))
        : (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("table", _hoisted_14, [
              _createElementVNode("tbody", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.groupAdminListInfo, (admininfo, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", _hoisted_16, _toDisplayString(admininfo.userId), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_17, _toDisplayString(admininfo.givenName), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_18, _toDisplayString(admininfo.familyName), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_19, _toDisplayString($setup.selGroup), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_20, _toDisplayString(admininfo.email), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_21, [
                      _createElementVNode("button", {
                        class: "btn btn-primary",
                        style: {"width":"20%"},
                        onClick: ($event: any) => ($setup.updateGroups(admininfo.userId,admininfo.givenName,admininfo.familyName,admininfo.email,$setup.selectedGroup))
                      }, " Edit ", 8 /* PROPS */, _hoisted_22)
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ]))
    ])
  ]))
}